import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { TabScrollButtonProps } from "@mui/material/TabScrollButton";
import IconButton from "designSystem/components/button/IconButton";
import React, { FunctionComponent } from "react";

export const TabScrollButton: FunctionComponent<TabScrollButtonProps> = (props) => {
	const { className, direction, disabled, onClick } = props;
	const isLeft = (direction === "left");

	return disabled ? null : (
		<IconButton
			className={className}
			design="secondary"
			onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent<EventTarget>>) => onClick(event as any)}
			res={isLeft ? "ScrollLeft" : "ScrollRight"}
			round
			size="small"
		>
			{isLeft ? <ChevronLeft /> : <ChevronRight />}
		</IconButton>
	);
};